import * as Yup from "yup";

export function buildValidationSchema(question) {
  let validator = Yup.mixed();

  if (question.required) {
    validator = validator.required("Please answer this question first");
  }

  return Yup.object({
    answer: validator,
  });
}
